import style from "./pickers.module.css";
import { MondayBoard } from "shared/integrations/mapper";
import classNames from "classnames";
import * as Select from "frontend/ui-components/select/select";

function Placeholder({ text, theme = "dark" }: { text: string; theme?: "light" | "dark" }) {
  return <div className={classNames(style.placeholder, style[theme])}>{text}</div>;
}

export function BoardGroupPicker({
  board,
  selectedId,
  setSelectedId,
  theme = "light",
}: {
  board?: MondayBoard;
  selectedId: string;
  setSelectedId: (id: string) => void;
  theme?: "light" | "dark";
}) {
  const groups = board?.groups.map((group) => ({ id: group.id, name: group.title })) ?? [];

  const mainLabel =
    board && !!selectedId ? (
      groups.find((group) => group.id === selectedId)?.name
    ) : (
      <Placeholder text="Choose group" theme={theme} />
    );

  return (
    <Select.Select selectedId={selectedId} setSelectedId={setSelectedId} allowOpenOptions={!!board}>
      <Select.Trigger customClass={classNames(style.selectTrigger, style[theme])}>
        <div style={{ display: "inline-block", textOverflow: "ellipsis", overflow: "hidden", whiteSpace: "nowrap" }}>
          {mainLabel}
        </div>
        <Select.Arrow theme={theme} />
      </Select.Trigger>
      <Select.Popover className={classNames(style.background, style.popover, style.rounded, style[theme])}>
        <Select.OptionsList>
          <div className={style.popoverChildren}>
            {groups.map((group) => (
              <Select.Option id={group.id} key={group.id}>
                <div className={classNames(style.boardPickerOption, selectedId == group.id && style.selected)}>
                  {group.name}
                </div>
              </Select.Option>
            ))}
          </div>
        </Select.OptionsList>
      </Select.Popover>
    </Select.Select>
  );
}
